export default __webpack_public_path__ + "static/media/ВКО_Зайсанский_район,_Тарбагатайский_район.eba93b5c.svg";